const SSLCertificateHelper = () => null;

export default SSLCertificateHelper;
